<template>
  <form @submit.prevent="updatePassword" class="grid-container">
   <legend><span><strong>Change your password</strong></span></legend><br />
    <div class="input-wrapper">
      <label for="password"
        >Current Password</label
      >
      <input
        type="password"
        id="current-password"
        v-model="currentPassword"
      />
    </div>
    <div class="input-wrapper">
      <label for="password">Password</label>
      <input
        type="password"
        id="password"
        v-model="password"
      />
    </div>
    <div class="input-wrapper">
      <label for="password-confirm"
        >Confirm Password</label
      >
      <input
        type="password"
        id="password-confirm"
        v-model="passwordConfirm"
      />
    </div>
    <BaseBtn type="submit" text="Update" />
    <FlashMessage :message="message" :error="error" />
  </form>
</template>

<script>
import { getError } from "../utils/helpers";
import BaseBtn from "./BaseBtn";
import AuthService from "../services/AuthService";
import FlashMessage from "./FlashMessage";

export default {
  name: "UpdatePassword",
  components: {
    BaseBtn,
    FlashMessage,
  },
  data() {
    return {
      currentPassword: null,
      password: null,
      passwordConfirm: null,
      error: null,
      message: null,
    };
  },
  methods: {
    updatePassword() {
      this.error = null;
      this.message = null;
      const payload = {
        current_password: this.currentPassword,
        password: this.password,
        password_confirmation: this.passwordConfirm,
      };
      AuthService.updatePassword(payload)
        .then(() => (this.message = "Password updated."))
        .catch((error) => (this.error = getError(error)));
    },
  },
};
</script>
